import React from "react";
import GameButtonWithText from "./GameButtonWithText";
import GameData from "../../gameplay/model/GameData";
import GameController from "../../gameplay/controllers/GameController";
import {DAY_NAMES, GAME_BUTTONS_NEXT_NAME, INFRA_TYPE} from "../../constants/Constants";
import calendar_icon from "../../images/gameplay_ui/icons/calendar.svg"
import star_full from "../../images/gameplay_ui/icons/star_full.svg"
import star_empty from "../../images/gameplay_ui/icons/star_empty_ingame.svg"
import {MaxSecurityLevel} from "../../gameplay/model/Balance";
import GamePopup from "./Windows/GamePopup";
import * as GameStyleUI from "./GameStyleUI";
import agent from "../../agent";
import UtilsFunctions from "../../utils/UtilsFunctions";

export default class GameTopPanel extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isShowNextPhasePopup: false,
            showTrainsConfirm: false,
            trainsErrorInfo: "",
            trains: []
        }
    }
    onNextButtonPressed(){
        let directorIndex = UtilsFunctions.getRoleNameIndex("Руководитель компании");

        if (!UtilsFunctions.playerHasRole(directorIndex)) {
            alert("Сменять фазу игры может только Руководитель компании!");
            return;
        }

        for (let shop of GameData.CurrentGame.repairShops) {
          const parts = shop.partsType === INFRA_TYPE ?
            GameController.calculateAvaliablePartsPath(shop)
            : GameController.calculateParts(shop)
          const people = shop.partsType === INFRA_TYPE ?
            GameController.calculateAvaliableBrigadesChipsPath(shop):
            GameController.calculateRepairBrigadeChips(shop)

          if (parts < 0) {
            alert('В ремонтном цехе отрицательные запчасти!');
            return;
          }

          if (people < 0) {
            alert('В ремонтном цехе отрицательные трудозатраты!');
            return;
          }
        }

        if (GameData.CurrentGame.state === 4) {
            let validation = GameController.validateTrainsOnStation();

            if (!validation.status) {
                this.setState({
                    trains: validation.trains,
                    showTrainsConfirm: true,
                    trainsErrorInfo: validation.error
                });
                return;
            }
        }

        if (GameData.CurrentGame.state === 5) {
            let validation = GameController.validateEndEvening(GameData.CurrentGame, GameData.CurrentGame.currentTrains);

            if (!validation.status) {
                alert(validation.error, false, true);
                return;
            }
        }

        this.setState({
            isShowNextPhasePopup: true
        });
    }

    closePopups() {
        this.setState({
            isShowNextPhasePopup: false,
            showTrainsConfirm: false
        });
    }

    freeAllTrainsOnStations() {
        GameController.freeAllTrainsOnStations(this.props.teamID, this.state.trains, GameData.CurrentGame);

        this.setState({
            trains: []
        });
    }

    changeState() {
        if (this.state.trains.length) {
            this.freeAllTrainsOnStations();
        }

        agent.GamePlay.changeTeamState(this.props.teamID, () => {});
        this.closePopups();
    }

    render() {
        let mainStyle = {
            display: "flex",
            width: "550px",
            height: "50px",
            justifyContent: "space-between"
        }
        let blackBG = {
            background: 'rgba(0, 0, 0, 0.5)',
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: "3px"
        }
        let dayTextStyle = {
            fontSize: "20px",
            fontWeight: "bold",
            margin: "auto",
            weight: "bold",
            color: "white",
            textTransform: "uppercase"
        }
        let stars = [];
        for (let i = 0; i <MaxSecurityLevel; i++){
            stars.push(<img alt={'star'+i} key={i} src={GameData.CurrentGame.securityLevel > i ? star_full : star_empty}/>)
        }

        let trainsConfirm = <GamePopup
            title={"Подтвердите"}
            message={this.state.trainsErrorInfo}
            width={GameStyleUI.UserGameViewSize.width}
            height={GameStyleUI.UserGameViewSize.height}
            onOk={this.changeState.bind(this)}
            onCancel={this.closePopups.bind(this)}
        />

        let confirmChangeState = <GamePopup
            title={"Конец фазы"}
            message={"Вы уверены, что хотите закончить действия? Данное действие нельзя будет отменить."}
            width={GameStyleUI.UserGameViewSize.width}
            height={GameStyleUI.UserGameViewSize.height}
            onOk={this.changeState.bind(this)}
            onCancel={this.closePopups.bind(this)}
        />;

        let dayButton = DAY_NAMES[GameData.CurrentGame.day];
        let dayName = (GameData.CurrentGame.state === 5 ? ` (${dayButton})` : "");
        return <div style={mainStyle}>
            <div style={{
                ...blackBG,
                width: "163px"
            }}>
                <div style={{
                    width: "40px",
                    height: "40px",
                    marginLeft: "5px",
                    background: "url("+ calendar_icon + ") no-repeat",
                    backgroundSize: "contain",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{
                        paddingTop: "12px",
                        fontSize: "20px",
                        fontWeight: "bold"
                    }}>
                        {GameData.CurrentGame.year + 1}
                    </div>

                </div>
                <div style={dayTextStyle}>{dayButton}</div>
            </div>
            <div style={{
                ...blackBG,
                width: "160px",
                padding: "10px"
            }}   title={"Уровень безопасности"}>
                {stars}
            </div>
            <GameButtonWithText title={GAME_BUTTONS_NEXT_NAME[GameData.CurrentGame.state] + dayName}  width={194} height={50} fontSize={20} onClick={this.onNextButtonPressed.bind(this)}/>
            {this.state.isShowNextPhasePopup && confirmChangeState}
            {this.state.showTrainsConfirm && trainsConfirm}
        </div>
    }
}
